<template>
  <div class="" v-if="title || body">
    <h6 v-if="title" class="text-grey-10">{{ title }}</h6>
    <p v-if="body" :class="{ 'q-pt-sm': title }">{{ body }}</p>
  </div>
</template>

<script>
export default {
  name: 'WelcomeMessage',
  props: {
    title: String,
    body: String
  }
};
</script>
